// extracted by mini-css-extract-plugin
export default {"CompleteAccountPage":"CompleteAccountPage_CompleteAccountPage__nTE2o","formWrapper":"CompleteAccountPage_formWrapper__+Lcm1","logo":"CompleteAccountPage_logo__i4pur"};